import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../../../../../mp-core/themes/palette"

export const useStyles = makeStyles()(({ spacing, palette }) => ({
  globalSearchPaper: {
    width: "100%",
    maxWidth: "360px",
    borderRadius: "2px",
    backgroundColor: palette.common.white
  },
  globalSearchPaperHeader: {
    padding: spacing(2),
    borderBottom: `2px solid ${blueGrey[100]}`
  }
}))
